import React from "react";

const TokenDetailsModal = ({ eventDetails, closeModal }) => {
  if (!eventDetails || eventDetails?.length === 0) return null;
  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 bg-[#000000B3] flex items-center justify-center">
      <div className="bg-white p-3 rounded-lg">
        <h6 className="uppercase my-2 text-center font-medium text-xl">
          Token members list
        </h6>
        <div className="overflow-x-auto shadow-md rounded-2xl max-h-[800px] ">
          <table className="min-w-full text-left text-sm text-gray-700 bg-white border border-gray-200 rounded-2xl">
            <thead className="bg-gray-100 text-gray-900 font-semibold">
              <tr>
                <td className="px-6 py-3 border-b">Token</td>
                <td className="px-6 py-3 border-b">Name</td>
                <td className="px-6 py-3 border-b">Type</td>
                <td className="px-6 py-3 border-b">Value</td>
                <td className="px-6 py-3 border-b">Mobile</td>
                <td className="px-6 py-3 border-b">City</td>
                <td className="px-6 py-3 border-b">Village</td>
              </tr>
            </thead>
            <tbody>
              {eventDetails?.map((items, i) => (
                <tr
                  className={`hover:bg-gray-50 ${
                    i % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
                >
                  <td className="px-6 py-3 border-b font-semibold">
                    {items.token || "-"}
                  </td>
                  <td className="px-6 py-3 border-b">
                    {items.name}, {items.family_name}
                  </td>
                  <td className="px-6 py-3 border-b">{items.asset_type}</td>
                  <td className="px-6 py-3 border-b">
                    {items.asset || items.amount}
                  </td>
                  <td className="px-6 py-3 border-b">{items.mobile}</td>
                  <td className="px-6 py-3 border-b">{items.city}</td>
                  <td className="px-6 py-3 border-b">{items.village}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-right">
          <button
            className="p-2 px-4 bg-gray-300 font-medium mt-5"
            onClick={() => closeModal()}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TokenDetailsModal;
